import { defineNuxtPlugin } from '#imports'
      import { plugin, defaultConfig, ssrComplete } from '@formkit/vue'
      import { resetCount } from '@formkit/core'

      import importedConfig from '/home/nodejs/kare-backoffice-v2/source/formkit.config.ts'

      export default defineNuxtPlugin((nuxtApp) => {
        const config = defaultConfig(typeof importedConfig === 'function' ? importedConfig() : importedConfig)
        nuxtApp.hook('app:rendered', (renderContext) => {
          resetCount()
          ssrComplete(nuxtApp.vueApp)
        })
        nuxtApp.vueApp.use(plugin, config)

      })
      